export const COMPANY = {
  legalName: "CRESTUS ECCOMMERCE PRIVATE LIMITED",
  brand: "CRESTUS",
  description:
    "CRESTUS ECCOMMERCE PRIVATE LIMITED is an online clothing retailer. The company is engaged in the retail and wholesale sale, trading and online marketing of men's and women's apparel and garments through its e-commerce platform.",
  address:
    "804 Krupal Pathshala, Shivranjani Char Rasta, Jodhpur Char Rasta, Ahmedabad, Ahmadabad City, Gujarat, India.",
  email: "support@crestuseccommerce.store",
  phone: "+91 90819 54805",
  cin: "U46901GJ2026PTC177540",
  gstin: "24AANCC8195Q1ZO",
};
